import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import SubHeader from "../../components/SubHeader";
import grave from '../../img/grave.png';
import MafiaService from "../../services/mafiaService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { setDeadView } from "../../store/gameSlice";
import { IDeadView } from "../../types/IDeadView";
import { showErrorToast } from "../../store/messageSlice";
import { DeadModeEnum } from "../../types/deadModeEnum";
import ScenarioUtils from "../../utils/scenarioUtils";
import { RoleClassEnum } from "../../types/roleClassEnum";
import GameLogs from "../../components/GameLogs";

function End() {
    const dispatch = useDispatch();
    const { serverName } = useSelector((state: RootState) => state.general);
    const { playerView, deadView } = useSelector((state: RootState) => state.game);
    const [deadMode, setDeadMode] = useState(DeadModeEnum.Dead);

    useEffect(() => {
        getDeadView();
    }, []);

    const getDeadView = () => {
        MafiaService.GetDeadView(serverName, (is_ok, payload) => {
            if (is_ok) {
                dispatch(setDeadView(payload as IDeadView));
            } else {
                dispatch(showErrorToast(payload))
            }
        });
    }

    if (deadMode === DeadModeEnum.Logs) {
        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <SubHeader>
                    End Game Logs
                </SubHeader>
                <GameLogs/>
            </div>
            <Footer>
                <button onClick={() => setDeadMode(DeadModeEnum.Dead)}>Back</button>
                <button onClick={() => getDeadView()}>Refresh</button>
            </Footer>
        </div>
    }

    const getSummary = () => {
        if (!(deadView?.state?.length || 0 > 0))
            return <div>Loading...</div>
        if (!(playerView?.winners || 0 > 0))
            return <div>Loading...</div>

        const getRow = (index: number, playerName: string, roleName: string, isDead: boolean) => {
            const role = ScenarioUtils.CheckRole(roleName);
            let label = 'T';
            let labelClass = 'label-town';
            if (role === RoleClassEnum.Mafia) {
                label = 'M';
                labelClass = 'label-mafia';
            } else if (role === RoleClassEnum.Neutral) {
                label = 'N';
                labelClass = 'label-neutral';
            }

            return <div className={`dead-man-row`} key={index}>
                <div className={`label ${labelClass}`}>{label}</div>
                <div className="pos">{index + 1}</div>
                <div className={`name ${isDead ? 'mafia' : ''}`}>{`${roleName} ${playerName}`}</div>
                {isDead ? <div className="status label label-mafia">DEAD</div> : <div className="status label label-town">ALIVE</div>}
            </div>
        }

        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <div className="mafia-lobby-container mafia-list-container">
                    <div className="town">Winners:</div>
                    <div className="mafia-player-list dead-man-list">
                        {deadView?.state?.map((deadPlayer, index) => {
                            if (playerView?.winners.indexOf(index) === -1)
                                return <span key={index}></span>
                            return getRow(index, deadPlayer.name, deadPlayer.role_name, deadPlayer.is_dead);
                        })}
                    </div>
                    <div className="mafia">Loosers:</div>
                    <div className="mafia-player-list dead-man-list">
                        {deadView?.state?.map((deadPlayer, index) => {
                            if (playerView?.winners.indexOf(index) !== -1)
                                return <span key={index}></span>
                            return getRow(index, deadPlayer.name, deadPlayer.role_name, deadPlayer.is_dead);
                        })}
                    </div>
                </div>
            </div>
        </div>
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>
                Game Ended
            </SubHeader>
            <div className="game-content">
                {getSummary()}
            </div>
        </div>
        <Footer>
            <button onClick={() => setDeadMode(DeadModeEnum.Logs)}>Logs</button>
        </Footer>
    </div>
}

export default End;